import { Flex } from '@reckon-web/flex';
import { ThemeProvider, useTheme } from '@reckon-web/theme';

import { Wrapper } from '../Wrapper';

import { Navigation } from './Navigation';
import { Logo } from './Logo';
import { Profile } from './Profile';

type HeaderProps = {
  handleSetUserToUpdateId: (user: string | null) => void;
};

export const Header = ({ handleSetUserToUpdateId }: HeaderProps) => {
  const { palette } = useTheme();

  return (
    <ThemeProvider
      theme={{
        colors: {
          accent: '#3EBA63',
          background: '#233365',
          text: '#FFFFFF',
        },
      }}
      paletteResolver={() => ({
        background: {
          dialog: palette.background.dialog,
        },
        menuItem: palette.menuItem,
      })}
    >
      <Wrapper>
        <Flex
          background="base"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          minHeight="64px"
          wrap
        >
          <Flex alignItems="center" gap="xxlarge" height="100%">
            <Logo />
            <Navigation />
          </Flex>

          <Flex gap="medium" alignItems="center" height="100%">
            <Profile handleSetUserToUpdateId={handleSetUserToUpdateId} />
          </Flex>
        </Flex>
      </Wrapper>
    </ThemeProvider>
  );
};
